// The selected document, beside the list (TX-US-0034): an image inline, a PDF in the browser's
// own viewer, both on the inline URL the API issues. A Word or Excel file has no preview; the
// pane says so and offers the download.

import { useEffect, useState } from 'react';

import { getCounterpartyDocumentDownload } from '../../api.js';
import Icon from '../../ui/Icon.jsx';
import { isImage, previewable } from './files.js';

export default function DocumentPreview({ counterpartyId, document, onDownload }) {
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState(null);
  const shown = previewable(document);

  // The URL is short-lived and per file; fetched when the selection changes, dropped when it
  // changes again so a slow answer for the last file cannot land on this one.
  useEffect(() => {
    setPreview(null);
    setError(null);
    if (!shown) return undefined;
    let cancelled = false;
    getCounterpartyDocumentDownload(counterpartyId, document.document_id, { inline: true })
      .then(({ download_url: url }) => {
        if (!cancelled) setPreview(url);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message);
      });
    return () => {
      cancelled = true;
    };
  }, [counterpartyId, document.document_id, shown]);

  return (
    <div className="attachment-preview" role="region" aria-label={`Preview of ${document.filename}`}>
      {error && <p className="error">{error}</p>}
      {shown && !preview && !error && <p className="muted">Loading…</p>}
      {preview && isImage(document) && <img src={preview} alt={document.filename} />}
      {preview && !isImage(document) && <iframe src={preview} title={document.filename} />}
      {!shown && (
        <div className="no-preview">
          <p className="muted">No preview for this file type.</p>
          <button type="button" onClick={() => onDownload(document)}>
            <Icon name="download" /> Download {document.filename}
          </button>
        </div>
      )}
    </div>
  );
}
